import { createContext, useEffect, useMemo, useState } from "react";

import { useUser } from "../hooks/useUser";
import { USER_TYPE } from "../constants";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { useGetUserProfile } = useUser();

  const userId = localStorage.getItem("userId");

  const [profile, setProfile] = useState({});

  const { data, isLoading } = useGetUserProfile(
    { userId },
    (data) => data.data
  );

  const isAuthenticated = useMemo(
    () =>
      !!(
        profile &&
        typeof profile === "object" &&
        Object.keys(profile)?.length
      ),
    [profile]
  );

  const isAdmin = useMemo(
    () =>
      !!(
        profile &&
        (profile?.userType === USER_TYPE.ADMIN ||
          profile?.role?.permissions?.includes("ADMIN_Access"))
      ),
    [profile]
  );

  const roleCode = useMemo(
    () => (profile?.role?.roleCode ? profile.role.roleCode : USER_TYPE.NONE),
    [profile]
  );

  useEffect(() => {
    if (data && !isLoading) {
      setProfile(data);
    }
  }, [data, isLoading]);

  return (
    <AuthContext.Provider
      value={{
        profile,
        setProfile,
        isAuthenticated,
        isAdmin,
        roleCode,
        isProfileLoading: isLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
